import { render, staticRenderFns } from "./HtDic.vue?vue&type=template&id=bfefd23e&scoped=true&"
import script from "./HtDic.vue?vue&type=script&lang=js&"
export * from "./HtDic.vue?vue&type=script&lang=js&"
import style0 from "./HtDic.vue?vue&type=style&index=0&id=bfefd23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfefd23e",
  null
  
)

export default component.exports